<template>
	<div>
		<span v-if="viewModel.id > 0">
			Reserva #{{ viewModel.id }}
			<b-badge
				:variant="viewModel.status == 'active' ? 'success' : 'danger'"
				>{{ viewModelStatusLabel }}</b-badge
			>
			<b-button-group class="ml-2" v-show="viewModel.status == 'active'">
				<b-badge variant="primary">Traveler Portal</b-badge>
				<b-button
					v-if="$hasPermission('reservation.copyTravelPortal')"
					variant="info"
					size="sm"
					title="Copiar link"
					@click="copyTravelersPortalUrl"
					><md-icon icon="content_copy"
				/></b-button>
				<b-button
					v-if="$hasPermission('reservation.linkTravelPortal')"
					title="Abrir"
					:href="viewModel.travelersPortalUrl"
					target="_blank"
					variant="warning"
					size="sm"
					><md-icon icon="launch"
				/></b-button>
			</b-button-group>
			<input
				style="width: 20px;position: absolute;left: -30px"
				ref="travelersPortalUrl"
				type="text"
				:value="viewModel.travelersPortalUrl"
			/>
		</span>
		<span v-else>
			Registrar Nueva Reserva
		</span>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
	computed: {
		...mapState("reservation", ["viewModel"]),
		viewModelStatusLabel() {
			return this.$root.auxVars.reservationStatusOpts.find(
				aux => aux.value == this.viewModel.status
			).text;
		}
	},
	methods: {
		copyTravelersPortalUrl() {
			let field = this.$refs.travelersPortalUrl;
			field.select();
			field.setSelectionRange(0, 999999);

      window.document.execCommand("copy");
      this.$root.showAlert("Link copiado!");
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 720px) {
  .u\:md\:ml-2 {
    margin-left: 0.5rem;
  }
}
</style>
